<template>
    <table v-if="oldRow instanceof Object && !Array.isArray(oldRow)">
      <tr v-for="k in allKeysOf(oldRow, newRow)" >
        <td class="name">{{ humanName(k) }}</td>
        <ChangeRow :name=k :oldRow=oldRow[k] :newRow=newRow[k] :meta=meta />
      </tr>
    </table>
    <td colspan="2" v-else-if="isStrLike(name)"><AttrDiff :isLong=isLong(name) :oldStr="oldRow" :newStr="newRow" /></td>
    <template v-else>
      <td class="from"><CellValue :value=oldRow :type=type(name) /></td>
      <td><CellValue :value=newRow :type=type(name) /></td>
    </template>
</template>  

<script>
import _ from "underscore"
import AttrDiff from "common/visual/history/AttrDiff.vue"
import CellValue from "common/visual/history/CellValue.vue"
import { useAttr } from "common/visual/history/useAttr.js"

export default {

  name: "ChangeRow",
  
  components: {AttrDiff, CellValue},
  
  props: {
    oldRow: null,
    newRow: null,
    meta: null,
    name: {
      type: String,
      default: "",      
    },
  },

  setup(props)
  {
    return useAttr(props.meta.system, props.meta.entity)
  },
  
  methods: {
    allKeysOf(rec1, rec2)
    {
      const keys = Object.keys(rec1).concat(Object.keys(rec2))
      const sorted = _.sortBy(keys, name => this.humanName(name))
      return _.unique(sorted, true)
    },
    
    attr(name, field)
    {
      return this.getAttr(name).value?.[field]
    },
    
    humanName(entname)
    {
      return this.attr(name, "human") || entname
    },

    type(entname)
    {
      return this.attr(entname, "type")
    },

    isStrLike(entname)
    {
      const t = this.type(entname)
      return ["string", "phone"].find(el => el == t)
    },
  
    isLong(entname)
    {
      const len = this.attr(entname, "length")
      return len && len>100
    },
  },
}
</script>

<style scoped>
table {
  border-collapse: collapse;
  width: 100%;
}
        
tbody tr:nth-child(even) {
  backdrop-filter: brightness(90%);
}

td.name {
  width: 10%;
  border-right: 1px solid lightgray;
  padding-left: 0;
  padding-right: 1em;
  font-weight: bold;
}

td {
  padding-left: 1em;
}
  
td.from {
  width: 45%;
  border-right: 1px solid lightgray;
}
</style>